__turbopack_context__.v({
  "cardContent": "CardContent-module__HdFsIq__cardContent",
  "cardContentFull": "CardContent-module__HdFsIq__cardContentFull",
  "cardContentOverflow": "CardContent-module__HdFsIq__cardContentOverflow",
  "cardContentWithAside": "CardContent-module__HdFsIq__cardContentWithAside",
  "cardContentWithMiniTitle": "CardContent-module__HdFsIq__cardContentWithMiniTitle",
  "cardContentWithPadding": "CardContent-module__HdFsIq__cardContentWithPadding",
  "cardContentWithTitle": "CardContent-module__HdFsIq__cardContentWithTitle",
});
